import { render, staticRenderFns } from "./FeedbackModal.vue?vue&type=template&id=c10ae224&scoped=true&"
import script from "./FeedbackModal.vue?vue&type=script&lang=js&"
export * from "./FeedbackModal.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackModal.vue?vue&type=style&index=0&id=c10ae224&lang=scss&"
import style1 from "./FeedbackModal.vue?vue&type=style&index=1&id=c10ae224&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10ae224",
  null
  
)

/* custom blocks */
import block0 from "./FeedbackModal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c10ae224')) {
      api.createRecord('c10ae224', component.options)
    } else {
      api.reload('c10ae224', component.options)
    }
    module.hot.accept("./FeedbackModal.vue?vue&type=template&id=c10ae224&scoped=true&", function () {
      api.rerender('c10ae224', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/FeedbackModal.vue"
export default component.exports